<template lang="pug">
  section.container(v-if="authUser")
    .logged-user-info
      div.logged-user-info__row
        div Logged in as
        div.logged-user-info__email {{ authUser.email }}
      div.logged-user-info__row
        span
          a.primary-link(:href="challengeBackendURL()" target="_blank" data-test="dashboard-button") Dashboard
          span.separator |
          a.primary-link(@click="logOutWithNotify" data-test="logout-button") Logout
</template>
<script>
import { mapGetters, mapActions, mapMutations, } from 'vuex'
import { EventBus, } from '@/event-bus'
import { CLEAR_CHALLENGE, } from '@/store/modules/record/modules/challenge/mutations-types'
import Challenge from '@/mixins/challenge'
import { challengeURL, } from '@/constants/api'

export default {
  mixins: [ Challenge, ],
  data () {
    return {
      confirmText: 'If you log out, all entered data will be lost.',
    }
  },
  computed: {
    ...mapGetters('auth', [ 'authUser', ]),
  },
  methods: {
    challengeBackendURL: () => `${challengeURL}raised-lei-challenges`,
    logOutWithNotify () {
      if (this.challengeMode) {
        this.$confirm(this.confirmText, {
          type: 'warning',
        }).then(() => {
          this.clearChallenge()
          EventBus.$emit('challenge-clear')
          this.logOut()
          this.$message({
            type: 'success',
            message: 'You have successfully logged out',
          })
          this.$router.push({ name: 'RecordDetailsPage', })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Challenge continues',
          })
        })
      } else {
        this.logOut()
        this.$message({
          type: 'success',
          message: 'You have successfully logged out',
        })
      }
    },

    ...mapMutations('record/challenge', {
      clearChallenge: CLEAR_CHALLENGE,
    }),
    ...mapActions('auth', [ 'logOut', ]),
  },
}
</script>
<style lang="stylus" scoped>
@import "../../assets/styles/variables.styl"

.logged-user-info
  display flex
  flex-direction column
  color $default-color-bold
  align-items flex-end

  &__row
    display flex
    flex-direction row
    align-items center
    justify-content flex-end
    margin-bottom 5px
    margin-top 5px

  &__email
    font-weight bold
    margin-left 5px

  .separator
    margin: 0 10px
    color $default-color-bold

@media screen and (max-width: $laptop)
  .logged-user-info
    align-items center
    text-align center
    font-size 12px

    &__email
      margin 5px 0

  .logged-user-info__row
    flex-direction column
    justify-content center
    margin 3px 0

  .primary-link
    margin: 5px 0
</style>



// WEBPACK FOOTER //
// src/components/record-details/UserInfoSection.vue